module.exports = __webpack_public_path__ + "static/img/Video01.f062cb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vidio/Video01.jpg
// module id = 7qW9
// module chunks = 0